module.exports = {"apiKey":"AIzaSyBWxDQ-oKfynjnJFXow998oy2KDzXyo88Q","authDomain":"wagm-test.firebaseapp.com","databaseURL":"https://wagm-test.firebaseio.com","projectId":"wagm-test","storageBucket":"wagm-test.appspot.com","messagingSenderId":"125636266886"}


//////////////////
// WEBPACK FOOTER
// ./src/config/firebase/test.json
// module id = 4690
// module chunks = 0